import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  features: Yup.string().required('Please write features')
});

export const initialValues = {
  features: ''
};
